import script from "./CompanyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyList.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyList.vue?vue&type=style&index=0&id=16fa5cda&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16fa5cda"]])

export default __exports__